<template>
  <div class="page">
    <div class="page-padding">
      <figure class="visual">
        <picture>
          <source media="(min-width: 550px)" srcset="img/visual-bahntechnik.jpg">
          <img src="img/visual-bahntechnik-small.jpg"/>
        </picture>
        <figcaption>
          <h1>Bahntechnik</h1>
        </figcaption>
      </figure>
      <h2 class="carousel-headline">Unsere Filme zum Thema Bahntechnik</h2>
      <bahntechnik-movies-list></bahntechnik-movies-list>
    </div>
  </div>
</template>

<script>

import BahntechnikMoviesList from './BahntechnikMoviesList.vue';

export default {
  components: {
    bahntechnikMoviesList: BahntechnikMoviesList
  },
  beforeRouteEnter(to, from, next) {
    window.scrollToTop();
    next();
  },
}
</script>



// WEBPACK FOOTER //
// Bahntechnik.vue?120f9a33